import {Injectable, Injector} from '@angular/core';
import {Observable} from 'rxjs';


import {BaseService} from '../base/base.service';
import {Currency} from '../../models/lookups/currency';
import {Query} from '../../models/query/query';
import {WebMethodResult} from '../../models/web-method-result';
import {AppModulePath} from '../../models/app-module-path';
import {HttpClient} from '@angular/common/http';
import {PlatformLocation} from '@angular/common';
import {catchError, map} from 'rxjs/operators';

@Injectable()
export class CurrencyService extends BaseService {
  private listUrl = '/api/currency/list';
  private postUrl = '/api/currency/save';
  private deleteUrl = '/api/currency/delete/';
  private nbsImportUrl = '/api/currency/nbs_import';

  constructor(protected injector: Injector,
              protected http2: HttpClient,
              protected platformLocation: PlatformLocation) {
    super(injector, http2, platformLocation);
  }

  list(qry: Query): Observable<Currency[]> {
    const url = this.listUrl + '?q=' + encodeURIComponent(JSON.stringify(qry));
    return this.get<Currency[]>(url, AppModulePath.CURRENCY).pipe(
      map(res => res.map(obj => new Currency(obj))),
      catchError(this.handleError));
  }

  save(currency: Currency): Observable<Currency> {
    return this.post<Currency>(this.postUrl, AppModulePath.CURRENCY, currency).pipe(
      map(res => new Currency(res)),
      catchError(this.handleError));
  }

  delete(id: string): Observable<WebMethodResult> {
    return this._delete<WebMethodResult>(this.deleteUrl + id, AppModulePath.CURRENCY).pipe(
      map(res => new WebMethodResult(res)),
      catchError(this.handleError));
  }

  nbsImport(onFinish: () => void) {
    return this.post(this.nbsImportUrl, AppModulePath.CURRENCY, '')
      .subscribe(onFinish, this.handleError);
  }
}
